import classnames from 'classnames';
import React, { Component } from 'react';

import { Translator } from '../../Translator';
import MapStyles from './MapStyles';

const CSS = require('./MeetingPointMap.module.scss');

declare const window: any;

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
// Mirrors Google Maps ControlPosition API where certain positions are intentional aliases
export enum MapControlsPostion {
  BOTTOM = 11,
  BOTTOM_CENTER = 11,
  BOTTOM_LEFT = 10,
  BOTTOM_RIGHT = 12,
  CENTER = 13,
  LEFT = 5,
  LEFT_BOTTOM = 6,
  LEFT_CENTER = 4,
  LEFT_TOP = 5,
  RIGHT = 7,
  RIGHT_BOTTOM = 9,
  RIGHT_CENTER = 8,
  RIGHT_TOP = 7,
  TOP = 2,
  TOP_CENTER = 2,
  TOP_LEFT = 1,
  TOP_RIGHT = 3,
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */
interface MeetingPointMapProps {
  location: {
    lat: number;
    lng: number;
  };
  setLocation?: (lat: number, lng: number) => void;
  draggable?: boolean;
  fullscreenControl?: boolean;
  zoomControlPosition?: MapControlsPostion;
  showLocation?: boolean;
  className?: string;
  height?: number | string;
}

class MeetingPointMap extends Component<MeetingPointMapProps> {
  static defaultProps = {
    showLocation: true,
  };

  componentDidMount() {
    if (!this.map) {
      this.setUpMapsServices();
    }
  }

  mapContainer: HTMLDivElement | null = null;
  markerCircle: {
    setCenter: (pos: { lat: number; lng: number }) => void;
    setVisible: (v: boolean) => void;
  } | null = null;
  marker: {
    getPosition: () => { lat: () => number; lng: () => number };
    setPosition: (pos: { lat: number; lng: number }) => void;
    setVisible: (v: boolean) => void;
    addListener: (event: string, handler: () => void) => void;
  } | null = null;
  map: {
    mapTypes: { set: (id: string, type: any) => void };
    setMapTypeId: (id: string) => void;
    panTo: (pos: { lat: number; lng: number }) => void;
  } | null = null;

  componentWillReceiveProps(nextProps: MeetingPointMapProps) {
    if (
      nextProps.location !== this.props.location &&
      nextProps.showLocation &&
      this.marker
    ) {
      this.updateMarkerAndMapPos(nextProps.location, nextProps.showLocation);
    }
  }

  setUpMapsServices = () => {
    try {
      if (!!window.google && !!window.google.maps && !!window.google.maps.Map) {
        this.createMap(this.props.location);
      } else {
        setTimeout(this.setUpMapsServices, 1000);
      }
    } catch (error) {
      console.warn('Map.js error: ', error);
    }
  };

  createMap = (location: { lat: number; lng: number }) => {
    const styledMapType = new window.google.maps.StyledMapType(MapStyles, {
      name: 'Styled Map',
    });
    this.map = new window.google.maps.Map(this.mapContainer, {
      scrollwheel: false,
      zoom: 15,
      center: location,
      draggable: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: this.props.fullscreenControl && true,
      zoomControlOptions: {
        position: this.props.zoomControlPosition,
      },
    });

    this.map.mapTypes.set('styled_map', styledMapType);
    this.map.setMapTypeId('styled_map');

    this.marker = new window.google.maps.Marker({
      map: this.map,
      position: location,
      draggable: this.props.draggable,
      raiseOnDrag: true,
      visible: this.props.showLocation,
    });
    this.createCircle(location);
    if (this.props.draggable) {
      this.marker.addListener('dragend', this.dropMarker);
    }
    this.setState({ mapInited: true });
  };

  createCircle = (location: { lat: number; lng: number }) => {
    this.markerCircle = new window.google.maps.Circle({
      map: this.map,
      strokeColor: '#E71575',
      strokeOpacity: 0.2,
      strokeWeight: 1,
      fillColor: '#E71575',
      fillOpacity: 0.4,
      center: location,
      radius: 50,
      visible: this.props.showLocation,
    });
  };

  dropMarker = () => {
    if (!this.marker || !this.props.setLocation) return;
    const { lat, lng } = this.marker.getPosition();
    this.props.setLocation(lat(), lng());
  };

  updateMarkerAndMapPos = (
    position: { lat: number; lng: number },
    showLocation: boolean,
  ) => {
    if (!this.marker || !this.markerCircle || !this.map) return;
    this.marker.setPosition(position);
    this.marker.setVisible(showLocation);
    this.markerCircle.setCenter(position);
    this.markerCircle.setVisible(showLocation);
    this.map.panTo(position);
  };

  setRef = (c: HTMLDivElement | null) => (this.mapContainer = c);

  render() {
    const showMap =
      this.props.location.lat !== 0 && this.props.location.lng !== 0;

    return (
      <div data-test-id="Map" className={CSS.MeetingPointMap}>
        {showMap && this.props.draggable && (
          <h5 className={CSS.SubTitle}>
            {Translator.translate(
              'UserEnvironment.LocationSelector.dragPinToExactMeetingLocation',
            )}
          </h5>
        )}
        <div
          className={classnames(
            CSS.MapContainer,
            {
              [CSS.MapContainerShow]: showMap,
              [CSS.MapContainerHide]: !showMap,
            },
            this.props.className,
          )}
          style={this.props.height ? { height: this.props.height } : {}}
          ref={this.setRef}
        />
      </div>
    );
  }
}

export default MeetingPointMap;
